export default "__VITE_ASSET__CynaESlp__"